import { useDispatch } from 'store/hooks';
import { useCallback } from 'react';
import { toggleFeatureToggle } from 'app/store/featureToggles/actions';

export const useDispatchToggleFeatureToggle = () => {
    const dispatch = useDispatch();
    return useCallback(
        (feature: string) => {
            dispatch(toggleFeatureToggle(feature));
        },
        [dispatch]
    );
};
